import React from 'react';
import { View } from 'native-base';
const sizes = {
  responsive: {
    desktop_left_column: {
      w: {
        base: '100%',
        lg: '60%'
      }
    },
    desktop_right_column: {
      w: '40%',
      display: {
        base: 'none',
        lg: 'block'
      }
    },
    mobile_full_width: {
      w: '100%',
      display: {
        base: 'block',
        lg: 'none'
      }
    }
  }
};

/** use this view for the left column of a left/right column desktop display
 * left column is 100% in mobile, while right column disappears in mobile
 *
 */
const DesktopLeftColumnView = props => {
  return /*#__PURE__*/React.createElement(View, {
    w: sizes.responsive.desktop_left_column.w
  }, props.children);
};

/** use this view for the right column of a left/right column desktop display
 * displays only in desktop
 *
 */
const DesktopRightColumnView = props => {
  return /*#__PURE__*/React.createElement(View, {
    w: sizes.responsive.desktop_right_column.w,
    display: sizes.responsive.desktop_right_column.display
  }, props.children);
};

/** use this view for component to only display in mobile, and display full width
 *
 */
const MobileFullWidthView = props => {
  return /*#__PURE__*/React.createElement(View, {
    w: sizes.responsive.mobile_full_width.w,
    display: sizes.responsive.mobile_full_width.display
  }, props.children);
};
export { DesktopLeftColumnView, DesktopRightColumnView, MobileFullWidthView };
//# sourceMappingURL=Views.js.map